import React, { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";

let AREAS_CACHE = null;

// Per-organization "Support Assignments" capability for a roster member (does not change roles or access).
export function SupportEligibility({ orgId, member, onChange }) {
  const [areas, setAreas] = useState(AREAS_CACHE || []);
  useEffect(() => {
    if (!AREAS_CACHE) api.get("/support-assignments/areas").then((r) => { AREAS_CACHE = r.data.items || []; setAreas(AREAS_CACHE); });
  }, []);
  if (!member.can_enable) return null;
  const allowed = member.allowed_areas || areas.map((a) => a.key);
  const save = async (enabled, list) => {
    try {
      await api.put(`/support-assignments/roster/${member.member_id}/eligibility`, { organization_id: orgId, enabled, areas: list });
      toast.success(enabled ? `Support Assignments on for ${member.name}` : `Support Assignments off for ${member.name}`);
      onChange();
    } catch (e) { toast.error(apiError(e)); }
  };
  const toggleArea = (k) => {
    const next = allowed.includes(k) ? allowed.filter((x) => x !== k) : [...allowed, k];
    if (!next.length) return toast.error("Keep at least one area, or turn Support Assignments off.");
    save(true, next);
  };
  return (
    <div className="mt-1.5 space-y-1.5">
      <label className="flex items-center gap-2 text-xs text-slate-600">
        <Switch checked={!!member.support_enabled} onCheckedChange={(v) => save(v, allowed)} data-testid={`roster-eligible-${member.member_id}`} />
        Support Assignments: <b data-testid={`roster-eligible-state-${member.member_id}`}>{member.support_enabled ? "ON" : "OFF"}</b>
        <span className="text-slate-400">({member.eligibility_source})</span>
      </label>
      {member.support_enabled && areas.length > 0 && (
        <div className="flex flex-wrap gap-1" data-testid={`roster-areas-${member.member_id}`}>
          {areas.map((a) => (
            <button key={a.key} type="button" onClick={() => toggleArea(a.key)} data-testid={`roster-area-${member.member_id}-${a.key}`}
              className={`rounded-full border px-2 py-0.5 text-[11px] transition-colors ${allowed.includes(a.key) ? "border-brand/40 bg-brand/10 text-brand" : "border-slate-200 text-slate-400 line-through"}`}>
              {a.label}</button>))}
        </div>
      )}
    </div>
  );
}
